import React, { createContext, useState, useEffect, useContext } from 'react';

interface AuthContextProps {
   loggedIn: boolean;
   setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AuthContext = createContext<AuthContextProps | undefined>(undefined);